import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeIt from '@angular/common/locales/it';
import localeItExtra from '@angular/common/locales/extra/it';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeNl from '@angular/common/locales/nl';
import localeNlExtra from '@angular/common/locales/extra/nl';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import localePl from '@angular/common/locales/pl';
import localePlExtra from '@angular/common/locales/extra/pl';
import localeRu from '@angular/common/locales/ru';
import localeRuExtra from '@angular/common/locales/extra/ru';
import localeSk from '@angular/common/locales/sk';
import localeSkExtra from '@angular/common/locales/extra/sk';

import { TruncatePipe } from './pipes/truncate';
import { FirstLetterPipe } from './pipes/first-letter.pipe';
import { CheckboxModule } from 'primeng/checkbox';
import { TreeModule } from 'primeng/tree';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { LanguageDialogModule } from './components/language/language.dialog.module';
import { CardModule } from 'primeng/card';
import { CalendarModule } from 'primeng/calendar';
import { RippleModule } from 'primeng/ripple';
import { ProfileComponent } from './components/profile/profile.component';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PasswordModule } from 'primeng/password';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DividerModule } from 'primeng/divider';
import { ClouseAccountComponent } from './components/close-account/close-account.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { LocalizedDatePipe } from './pipes/locale-date.pipe';
import { FilesDialogComponent } from './components/files-dialog/files.dialog.component';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SiteSelectorComponent } from './components/site-selector/site-selector.component';
import { SiteSelectorDialogComponent } from './components/site-selector-dialog/site-selector.dialog.component';
import { BadgeModule } from 'primeng/badge';
import { TagModule } from 'primeng/tag';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { AddGatewayDialogComponent } from './components/add-gateway-dialog/add-gateway-dialog.component';
import { SlimTopBarComponent } from './components/slim-topbar/slim.topbar.component';
import { BetaFeDialogComponent } from './components/beta-fe-dialog/beta-fe.dialog.component';
import { CommonFooterComponent } from './components/common-footer/common.footer.component';
import { CommonTopBarComponent } from './components/common-topbar/common.topbar.component';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { NotificationsModule } from "./components/notifications/notifications.module";
import { BusCalculationFooterComponent } from './components/busCalculation-footer/buscalculation.footer.component';
import { ReleaseNoteDialogComponent } from './components/release-note-dialog/release-note.dialog.component';
import { PrivacyNoteDialogComponent } from './components/privacy-note-dialog/privacy-note.dialog.component';
import { RatingDialogComponent } from './components/rating-dialog/rating-dialog.component';
import { RatingModule } from 'primeng/rating';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ReleaseNoteDeviceDialogComponent } from './components/release-note-device-dialog/release-note-device.dialog.component';
import { SiteCardDesktopMobileComponent } from './components/site-card/site-card-desktop-tablet.component';
import { SiteCardMobileComponent } from './components/site-card/site-card-mobile.component';
import { MenuModule } from 'primeng/menu';

registerLocaleData(localeFr, 'fr-FR', localeFrExtra);
registerLocaleData(localeIt, 'it-IT', localeItExtra);
registerLocaleData(localeDe, 'de-DE', localeDeExtra);
registerLocaleData(localeNl, 'nl-NL', localeNlExtra);
registerLocaleData(localeRu, 'ru-RU', localeRuExtra);
registerLocaleData(localeEs, 'es-ES', localeEsExtra);
registerLocaleData(localePl, 'pl-PL', localePlExtra);
registerLocaleData(localeSk, 'sk-SK', localeSkExtra);


@NgModule({
	declarations: [
		// Pipe
		FirstLetterPipe,
		LocalizedDatePipe,
		TruncatePipe,
		// Components
		AddGatewayDialogComponent,
		BetaFeDialogComponent,
		BusCalculationFooterComponent,
		ClouseAccountComponent,
		CommonFooterComponent,
		CommonTopBarComponent,
		FilesDialogComponent,
		PrivacyNoteDialogComponent,
		ProfileComponent,
		RatingDialogComponent,
		ReleaseNoteDeviceDialogComponent,
		ReleaseNoteDialogComponent,
		SiteCardDesktopMobileComponent,
		SiteCardMobileComponent,
		SiteSelectorComponent,
		SiteSelectorDialogComponent,
		SlimTopBarComponent
	],
	imports: [
		AccordionModule,
		AutoCompleteModule,
		BadgeModule,
		ButtonModule,
		CalendarModule,
		CardModule,
		CheckboxModule,
		CommonModule,
		ConfirmDialogModule,
		DividerModule,
		DropdownModule,
		FileUploadModule,
		FormsModule,
		InputTextModule,
		InputTextareaModule,
		LanguageDialogModule,
		MenuModule,
		NotificationsModule,
		PasswordModule,
		ProgressSpinnerModule,
		RadioButtonModule,
		RatingModule,
		ReactiveFormsModule,
		RippleModule,
		TableModule,
		TagModule,
		ToggleButtonModule,
		TooltipModule,
		TranslateModule,
		TreeModule
	],
	exports: [
		// Pipe
		FirstLetterPipe,
		LocalizedDatePipe,
		TruncatePipe,
		// Module
		ConfirmDialogModule,
		TranslateModule,
		// Components
		BetaFeDialogComponent,
		BusCalculationFooterComponent,
		CommonFooterComponent,
		CommonTopBarComponent,
		FilesDialogComponent,
		PrivacyNoteDialogComponent,
		RatingDialogComponent,
		ReleaseNoteDeviceDialogComponent,
		ReleaseNoteDialogComponent,
		SiteSelectorComponent,
		SiteSelectorDialogComponent,
		SiteCardDesktopMobileComponent,
		SiteCardMobileComponent,
		SlimTopBarComponent,
	]
})
export class SharedModule { }
